"use client";

import { cn } from "@watt/common/utils/classname-tailwind-merge";
import { OTPInput as OTPInputComponent, type SlotProps } from "input-otp";
import { memo, useId } from "react";
import { Label } from "./label";

interface OTPInputProps {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  maxLength?: number;
  label?: string;
  disabled?: boolean;
  className?: string;
}

const Slot = memo(function Slot(props: SlotProps) {
  return (
    <div
      className={cn(
        "flex h-12 flex-1 items-center justify-center rounded-md border border-input bg-background font-medium text-foreground shadow-xs transition-[color,box-shadow]",
        { "z-10 border-ring ring-[3px] ring-ring/50": props.isActive }
      )}
    >
      {props.char !== null && <div>{props.char}</div>}
    </div>
  );
});

export function OTPInput({
  value,
  onChange,
  onComplete,
  maxLength = 6,
  label,
  disabled = false,
  className
}: OTPInputProps) {
  const id = useId();

  return (
    <div className={cn("flex flex-col gap-3", className)}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <OTPInputComponent
        containerClassName="flex items-center gap-3 has-disabled:opacity-50"
        disabled={disabled}
        id={id}
        maxLength={maxLength}
        onChange={onChange}
        onComplete={onComplete}
        render={({ slots }) => (
          <div className="flex w-full gap-2">
            {slots.map((slot, idx) => (
              <Slot key={`otp-slot-${slot.char ?? "empty"}-${idx}`} {...slot} />
            ))}
          </div>
        )}
        value={value}
      />
    </div>
  );
}
